export default __webpack_public_path__ + "static/media/2-3-3.ec6d7614.jpg";